import { render } from "./CelebrityTwinsReportsDashboard.vue?vue&type=template&id=cb0a174c&scoped=true"
import script from "./CelebrityTwinsReportsDashboard.vue?vue&type=script&lang=js"
export * from "./CelebrityTwinsReportsDashboard.vue?vue&type=script&lang=js"

import "./CelebrityTwinsReportsDashboard.vue?vue&type=style&index=0&id=cb0a174c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb0a174c"]])

export default __exports__